"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when the max retry wait time limit has been exceeded when making a
 * batch request
 * @param {number} totalItems the total number of items attempted
 * @param {number} numRemainingItems the number of items that have not been processed yet
 * @param {number} numUnprocessedItems the number of unprocessed items returned
 */
class ExceededRetryWaitError extends ExtendableError_1.default {
    constructor(totalItems, numRemainingItems = 0, numUnprocessedItems = 0) {
        super('Exceeded retry wait max value - ' +
            `total items: ${totalItems}, ` +
            `number of remaining items: ${numRemainingItems}, ` +
            `number of unprocessed items: ${numUnprocessedItems}`);
        this.totalItems = totalItems;
        this.numRemainingItems = numRemainingItems;
        this.numUnprocessedItems = numUnprocessedItems;
        this.totalItems = totalItems;
        this.numRemainingItems = numRemainingItems;
        this.numUnprocessedItems = numUnprocessedItems;
    }
}
exports.default = ExceededRetryWaitError;
